// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__PX7yl","backButton":"PageHeader_backButton__K221+","title":"PageHeader_title__Y52mW","subtitle":"PageHeader_subtitle__KBcM4"};